<template>
  <div class="index">
    <div class="list">
      <div class="item">
        <div class="tel">退货原因</div>
        <div class="row">
          <textarea placeholder="请在这里输入您的退货原因" v-model="refund_reason"></textarea>
        </div>
      </div>
	  <div class="item">
	    <div class="row2">
	      <div class="tel">退款金额</div>
	      <div class="tel4">￥{{pay_price}}</div>
	    </div>
	  </div>
	  <div class="item">
	    <div class="tel">申请说明</div>
	    <div class="row">
	      <textarea placeholder="请在这里输入您的申请原因" v-model="apply_desc"></textarea>
	    </div>
		<div class="pictrue">
		  <VueCoreImageUpload
		    class="aa"
		    :crop="false"
		    compress="80"
		    @imageuploaded="imageuploaded"
		    :headers="headers"
		    :max-file-size="5242880"
		    :credentials="false"
		    inputAccept="image/*"
		    inputOfFile="file"
		    :url="url"
		    ref="upImg"
		  >
		    <div class="pictrue" v-if="cjimg">
				<img :src="cjimg" />
			  
		    </div>
			<div class="pictrue" v-else>
			  <img src="../../../public/tu.jpg" />
			</div>
		  </VueCoreImageUpload>
		</div>
	  </div>
      <div class="item">
        <div class="row">
          <div class="tel">联系电话</div>
          <div class="tel2">
			  <input type="number" placeholder="请输入您的联系电话" v-model="user_concat" />
		  </div>
        </div>
      </div>

    </div>
    <div class="btn"><div class="btnsure" @click="apply()">提交申请</div></div>
    </div>
  </div>
</template>

<script>
	import VueCoreImageUpload from "vue-core-image-upload";
	import { VUE_APP_API_URL } from "@utils";
	import { recede } from "@api/order";
		
	
export default {
  name: "refund",
  components: {
    VueCoreImageUpload
  },
  data() {
    return {
		url: `${VUE_APP_API_URL}/upload/image`,
		headers: {
		  Authorization: "Bearer " + this.$store.state.app.token
		},
		cjimg:'',
		orderid:'',
		productInfo:{},
		refund_reason:'',
		apply_desc:'',
		user_concat:'',
		pay_price:this.$route.query.pay_price
    };
  },
  methods: {
	imageuploaded(res) {
	  if (res.status !== 200)
	    return this.$dialog.error(res.msg || "上传图片失败");
	  this.cjimg = res.data.url;
	},
	apply(){
		let that = this;
		if(this.refund_reason==""|| this.refund_reason == null){
			return this.$dialog.toast({mes: "请输入退货原因"});
		}
		if(this.apply_desc==""|| this.apply_desc == null){
			return this.$dialog.toast({mes: "请输入申请说明"});
		}
		if(this.user_concat==""|| this.user_concat == null){
			return this.$dialog.toast({mes: "请输入联系电话"});
		}
				 that.orderid = that.$route.params.id;
				 let aa= {
					oid:this.$route.query.oid,
					product_id:this.$route.query.product_id,
					refund_reason:this.refund_reason,
					apply_desc:this.apply_desc,
					apply_pics:this.cjimg,
					user_concat:this.user_concat,
					apply_type:0,
					refund_price:this.$route.query.pay_price
				};
				recede(aa)
					.then(res => {
						that.$dialog.toast({mes:res.msg});
						this.$router.replace({ path: '/recede/recededetails',query: {id:res.data.id,apply_type:0}});
					})
					.catch(err => {
						that.$dialog.error(err.msg);
						this.$router.replace({ path: '/recede/recededetails',query: {id:res.data.id,apply_type:0}});
					});
	}
  },
  mounted() {

  }
};
</script>
<style scoped="scoped">
	.pictrue{
		    margin: 10px 0;
		    width: 100px;
		    height: 100px;

	}
	.pictrue img{
		width: 100%;
		height: 100%;
	}
.index {
  background-color: #f4f4f4;
  position: absolute;
  top: 0;
  bottom: 0;
}

.list {
  width: 100%;
  height: auto;
  padding: 15px;
  box-sizing: border-box;
}

.item {
  width: 100%;
  /* min-height: 100px; */
  background-color: #ffffff;
  border-radius: 5px;
  margin-bottom: 20px;
  padding: 20px 15px;
  box-sizing: border-box;
}

.row {
  width: 100%;
  /* height: 30px; */
  line-height: 30px;
  display: flex;
}

.tel {
  font-size: 15px;
  color: #000000;
  font-weight: bold;
  margin-right: 15px;
  line-height: 30px;
}

.tel2 {
  font-size: 13px;
}

.tel2 input {
  margin-left: 15px;
  margin-top: 7px;
  font-size: 12px;
  width: 200px;
}
.tel4{
	font-size: 16px;
	color: #000000;
	font-weight: bold;
	line-height: 30px;
}
.word {
  color: #333333;
  font-size: 12px;
  line-height: 25px;
}
.title {
  font-size: 15px;
  font-weight: ;
}
.row2 {
  display: flex;
  justify-content: space-between;
}
.tel3 {
  margin: 0 15px;
  margin-left: 21px;
  width: 60%;
}
.btn {
  width: 100%;
  height: 40px;
  position: fixed;
  bottom: 15px;
  padding: 0 15px;
  box-sizing: border-box;
}

.btnsure {
  width: 100%;
  height: 40px;
  font-size: 15px;
  color: #ffffff;
  line-height: 40px;
  text-align: center;
  background-color: #e02d26;
  border-radius: 10px;
}
.row textarea {
  font-size: 12px;
  width: 100%;
  min-height: 50px;
}
.picture{
    width: 0.96rem;
    height: 0.96rem;
    position: relative;
}
.aa{
	    position: relative;
	    overflow: hidden;
}
</style>
